import React, { useEffect } from 'react';
import { Form } from 'antd';

import { setStaticFormValuesFromFilter } from '../../common/filterHelpers';
import { SearchFormProps } from '../../common/searchFormField.types';
import { FormInput } from '../../components/forms/FormInput';
import { StyledColumn } from '../../components/StyledColumn';

export const ClientsSearchForm: React.FC<SearchFormProps> = ({ form, filter }) => {
  useEffect(() => setStaticFormValuesFromFilter(form, filter), [filter, form]);

  return (
    <Form form={form} style={{ flexGrow: '1' }}>
      <StyledColumn>
        <FormInput name={'name'} label="Client name" />
      </StyledColumn>
    </Form>
  );
};
